const currentNotification = state => state.notifications.bar.currentNotification

export default currentNotification
